/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateProductMappingRequest } from '../../models/create-product-mapping-request';
import { CreateProductMappingResponse } from '../../models/create-product-mapping-response';

export interface BulkCreateProductMappingFromRequest$Params {
      body: {
[key: string]: CreateProductMappingRequest;
}
}

export function bulkCreateProductMappingFromRequest(http: HttpClient, rootUrl: string, params: BulkCreateProductMappingFromRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<{
[key: string]: CreateProductMappingResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, bulkCreateProductMappingFromRequest.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/problem+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      [key: string]: CreateProductMappingResponse;
      }>;
    })
  );
}

bulkCreateProductMappingFromRequest.PATH = '/product-mappings/requests/create-product-mappings';
